import { render, staticRenderFns } from "./ModalUpdateLink.vue?vue&type=template&id=9d5be23e"
import script from "./ModalUpdateLink.vue?vue&type=script&lang=js"
export * from "./ModalUpdateLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports